import React from 'react'

const Terms = () => {
    return (
        <div id='terms' style={{ color: "white" }}>
            <h1>Terms of Service</h1>
            <p>Last Updated: 2/10/2026</p>


            <h2>1. Acceptance of Terms</h2>
            <p>
                By accessing and using this website ("Site"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Site.
            </p>

            <h2>2. Use of Our Services</h2>
            <p>
                You agree to use this Site only for lawful purposes. You are prohibited from violating any laws, transmitting malicious code, or attempting to gain unauthorized access to the Site.
            </p>

            <h2>3. Intellectual Property</h2>
            <p>
                All content on this Site, including text, images, and branding, is owned by Alpha Builders and may not be copied, modified, or distributed without permission.
            </p>

            <h2>4. Limitation of Liability</h2>
            <p>
                We are not liable for any direct, indirect, incidental, or consequential damages arising from the use of this Site.
            </p>

            <h2>5. Changes to These Terms</h2>
            <p>
                We may update these Terms at any time. Continued use of the Site constitutes acceptance of the updated Terms.
            </p>

            <h2>6. Contact Information</h2>
            <p>
                If you have any questions about these Terms, please contact us at <a href="mailto:support@alphabuilders-wa.com">support@alphabuilders-wa.com</a>.
            </p>

        </div>
    )
}

export default Terms